import { Button } from "@shadcn/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Rocket } from "lucide-react";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/one-delivery/onboarding/coming-soon")({
    beforeLoad: () => {
        document.title = 'bacehub | Startseite'
    },
	component: RouteComponent,
});

export default function RouteComponent() {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate({
			to: "/",
		});
	};

	return (
		<PageContainer
			className="px-6 mt-2 flex flex-col items-center justify-center"
			footer={
				<Button className="w-full shadow-xl" size="lg" onClick={handleGoHome}>
					Go back home
				</Button>
			}
		>
			<div className="flex flex-col items-center gap-6 text-center py-12">
				<div className="relative">
					<div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full" />
					<Rocket className="size-24 text-primary relative" />
				</div>

				<div className="space-y-4">
					<h1 className="text-3xl font-breit">Coming Soon!</h1>

					<p className="text-muted-foreground text-lg">This service is launching soon. We're working hard to bring it to you!</p>
				</div>
			</div>
		</PageContainer>
	);
}
